import { render, staticRenderFns } from "./SuperChallengeQuestion.vue?vue&type=template&id=2ae4c8d6"
import script from "./SuperChallengeQuestion.vue?vue&type=script&lang=js"
export * from "./SuperChallengeQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports